import QuestionEdit from './QuestionEdit'
import QuestionReview from './QuestionReview'

export default [
  {
    path: '/project/:project_id/question/:question_id?',
    name: 'QuestionEdit',
    component: QuestionEdit,
    meta: {auth: true, bodyClass: 'light-skin fixed-navbar sidebar-scroll fixed-footer', title: 'Question Edit'}
  }, {
    path: '/project/:project_id/question/:question_id/review',
    name: 'QuestionReview',
    component: QuestionReview,
    meta: {auth: true, bodyClass: 'light-skin fixed-navbar sidebar-scroll fixed-footer', title: 'Question Preview'}
  }
]



// WEBPACK FOOTER //
// ./src/pages/question/router.js